import {
  Badge,
  CircularProgress,
  TableCell,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
  Icon
} from "@material-ui/core";
import EmptyBody from "components/Table/EmptyBody.jsx";
import { GetUserId, GetUserKey, GetUserToken } from "helpers/UserHelper";
import { GetClientMessageHistory } from "queries/messaging/queries.js";
import React from "react";
import { Query } from "react-apollo";
import CMHContainer from "./containers/CMHContainer";

const columnData = [
  {
    id: "edit",
    numeric: false,
    disablePadding: true,
    label: "",
    noSort: true,
    width: "30px"
  },
  {
    id: "unread",
    numeric: false,
    disablePadding: true,
    label: "Unread",
    noSort: true
  },
  {
    id: "c.scd_surname",
    numeric: false,
    disablePadding: true,
    label: "Client Name"
  },
  {
    id: "m.date_sent",
    numeric: false,
    disablePadding: true,
    label: "Latest Message"
  }
];

class ClientMessageHistory extends React.Component {
  state = {
    page: 0,
    rowsPerPage: 5,
    order: "desc",
    orderBy: "m.date_sent",
    searchTerm: "",
    loadingSearch: false,
    searchData: [],
    openMenus: [],
    anchorTop: 0,
    anchorLeft: 0,
    popoverOpen: false,
    assistantActive: false,
    clientFound: false
  };

  handleSearch = (event, refetch) => {
    this.setState({ searchTerm: event.target.value });
    refetch();
  };

  handleChangePage = (page, refetch) => {
    this.setState({ page: page });
    refetch();
  };

  handleChangeRowsPerPage = (event, refetch) => {
    this.setState({ rowsPerPage: event.target.value });
    refetch();
  };

  handleRequestSort = (event, property, refetch) => {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }

    this.setState({ order, orderBy });

    refetch();
  };

  handleClick(client) {
    this.props.history.push({
      pathname: "/app/clientmessages",
      search: `clientId=${client.id}&clientName=${client.clientFullName}`
    });
  }

  checkAssistantActive() {
    if (GetUserKey("userType") === "6") {
      if (!this.state.assistantActive) {
        this.setState({ assistantActive: true });
      }
      return true;
    }
    return false;
  }

  getBrokerId = () => {
    let brokerId = GetUserId();
    if (this.checkAssistantActive()) {
      brokerId = sessionStorage.getItem("ActiveBrokerId");
    }
    return brokerId;
  };

  getBrokerName = () => {
    return sessionStorage.getItem("ActiveBrokerName");
  };

  render() {
    const colSpan = Object.keys(columnData).length;
    return (
      <Query
        query={GetClientMessageHistory}
        variables={{
          brokerId: this.getBrokerId(),
          token: GetUserToken(),
          limit: this.state.rowsPerPage,
          page: this.state.page,
          orderBy: this.state.orderBy,
          direction: this.state.order,
          search: this.state.searchTerm
        }}
        fetchPolicy="network-only"
      >
        {({ loading, error, data, refetch }) => {
          if (loading) {
            return (
              <CMHContainer
                {...this.state}
                brokerName={this.getBrokerName()}
                handleSearch={e => this.handleSearch(e, refetch)}
                handleRequestSort={(event, property) =>
                  this.handleRequestSort(event, property, refetch)
                }
                columnData={columnData}
                tableBody={
                  <EmptyBody
                    colSpan={colSpan}
                    rowSpan={this.state.rowsPerPage}
                    placeHolder={<CircularProgress />}
                  />
                }
              />
            );
          }
          if (error) return `Error! ${error.message}`;

          const items = data.ClientMessageHistory.Results;
          const count = data.ClientMessageHistory.Count;

          return (
            <CMHContainer
              {...this.state}
              brokerName={this.getBrokerName()}
              handleSearch={e => this.handleSearch(e, refetch)}
              handleRequestSort={(event, property) =>
                this.handleRequestSort(event, property, refetch)
              }
              columnData={columnData}
              tableBody={
                <React.Fragment>
                  {items.length < 1 && this.state.searchTerm !== "" ? (
                    <EmptyBody
                      colSpan={colSpan}
                      rowSpan={this.state.rowsPerPage}
                      placeHolder={
                        <Typography variant="subheading">
                          {this.state.searchTerm !== ""
                            ? "No results found"
                            : "No FNAs created yet. Click on Create FNA"}
                        </Typography>
                      }
                    />
                  ) : (
                    <React.Fragment>
                      {items.map(item => {
                        return (
                          <TableRow
                            className="sqDataTable"
                            key={item.id}
                            onClick={() => this.handleClick(item)}
                          >
                            <TableCell
                              style={{
                                padding: "0px",
                                borderRight: "1px solid #e0e0e0",
                                backgroundColor:"white"
                              }}
                            >
                              <IconButton>
                                <Icon>more_vert</Icon>
                              </IconButton>
                            </TableCell>
                            <TableCell
                              style={{
                                borderTop: "1px solid rgba(224, 224, 224, 1)",
                                width: "35px"
                              }}
                            >
                              {item.unread_messages > 0 ? (
                                <Badge
                                  color="primary"
                                  badgeContent={
                                    <strong>{item.unread_messages}</strong>
                                  }
                                />
                              ) : (
                                <Typography variant="caption" className="centerCell">0</Typography>
                              )}
                            </TableCell>
                            <TableCell>{item.clientFullName}</TableCell>
                            <TableCell>{item.latest_message_date}</TableCell>
                          </TableRow>
                        );
                      })}
                      {[...Array(this.state.rowsPerPage - items.length)].map(
                        (a, i) => {
                          return <TableRow key={i} colSpan={colSpan} />;
                        }
                      )}
                    </React.Fragment>
                  )}
                  <TableRow>
                    <TablePagination
                      count={count}
                      rowsPerPage={this.state.rowsPerPage}
                      page={this.state.page}
                      backIconButtonProps={{
                        "aria-label": "Previous Page"
                      }}
                      nextIconButtonProps={{
                        "aria-label": "Next Page"
                      }}
                      onChangePage={(event, page) =>
                        this.handleChangePage(page, refetch)
                      }
                      onChangeRowsPerPage={event =>
                        this.handleChangeRowsPerPage(event, refetch)
                      }
                    />
                  </TableRow>
                </React.Fragment>
              }
            />
          );
        }}
      </Query>
    );
  }
}

export default ClientMessageHistory;



// WEBPACK FOOTER //
// ./src/views/Messaging/ClientMessageHistory.jsx